module.exports = __webpack_public_path__ + "static/img/fgbg2-9.db4ce14.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-9.png
// module id = 200
// module chunks = 0